import React from 'react';

function Header(){
return (
<div className="text-center">
    <h1 className="text-2xl font-bold">Welcome to my fantastic coffee shop</h1>
</div>
);
}

export default Header;